module.exports = __webpack_public_path__ + "img/27.cbad0a00.jpg";